import styled from "styled-components";

export const CardErrorPage = styled.div`
  padding: 10px 15px;
  width: 100%;
`;
